export default {
    setSessionConversionData: (state: any, action: any) => {
        state.data = action.payload;
    },
    clearSessionConversionFilters: (state: any) => {
        state.queryParams = {};
    }
};

